import {Carousel} from '@customink/pigment-react';
import React from 'react';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import useRemToPX from '../../../../hooks/useRemToPX';

const CarouselCardsView = ({children}) => {
  const breakpoint = useBreakpoint();
  const gap = breakpoint === 'sm' ? useRemToPX(0.5) : useRemToPX(1);
  return (
    <Carousel
      sx={{
        '.arrow': {
          '&::before': {
            bottom: '-12px',
            content: '""',
            left: '-12px',
            position: 'absolute',
            right: '-12px',
            top: '-12px',
            zIndex: 1
          },
          position: 'relative',
          top: 'unset'
        },
        '.left': {
          left: '0.5rem'
        },
        '.right': {
          right: '0.5rem'
        },
        '.slider': {
          height: '400px'
        },
        '.keen-slider__slide': {
          '& .MuiCard-root:hover': {
            boxShadow: 'none !important'
          }
        },
        display: 'block',
        margin: 'auto',
        width: '100%'
      }}
      dots={false}
      sliderBg="transparent"
      slides={children}
      slidesPerView={4}
      sliderOrigin="auto"
      slidesSpacing={gap}
    />
  );
};

export default CarouselCardsView;
